export default function Icon({ width = 24, height = 24, color = "#171717" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.03508 8.80461C5.42561 8.41409 6.05878 8.41409 6.4493 8.80462L12.0024 14.3578L17.5556 8.80461C17.9462 8.41409 18.5793 8.41409 18.9699 8.80461C19.3604 9.19514 19.3604 9.8283 18.9699 10.2188L12.7095 16.4791C12.522 16.6667 12.2677 16.772 12.0024 16.772C11.7372 16.772 11.4829 16.6667 11.2953 16.4791L5.03508 10.2188C4.64455 9.8283 4.64456 9.19513 5.03508 8.80461Z"
        fill={color}
        fillOpacity="0.4"
      />
    </svg>
  );
}
